import React from 'react';
import { TableTrack } from './TrackTable';

export const TrackTablePublisherCell = (text, track: TableTrack): JSX.Element => {
  return <span>{track.publisher?.name}</span>;
};
